import { ImageOff } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Neutral, branded fallback tile rendered in place of a car photo that is
 * missing or fails to load (e.g. legacy listings whose only image origin is a
 * dead `driveshare-assets.com` 404, or an oversized/undecodable original the
 * variant backfill could not re-host). Fills its parent (`h-full w-full`) so it
 * slots into the same space as the `<img>` it replaces — used by CarCard, the
 * mobile CarCardImageCarousel and the detail PhotoGallery hero/lightbox to
 * avoid the browser's broken-image icon.
 *
 * The caller owns responsive display (e.g. wrap in `hidden sm:block`); this
 * component always renders as a flex tile so it never fights a `hidden` class
 * merged onto it.
 */
export function CarImagePlaceholder({
  label,
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex h-full w-full flex-col items-center justify-center gap-2 bg-muted text-muted-foreground",
        className,
      )}
    >
      <ImageOff className="h-8 w-8 opacity-60" aria-hidden />
      {label ? <span className="px-2 text-center text-sm">{label}</span> : null}
    </div>
  );
}
